export const authConstants = {
    errors: {
        loginFailed: "Login failed. Please try again.",
        updateMeFailed: "Failed to update your profile.",
    },
};
